import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import YourExpectedCharge from './your-expected-charge';
import MultiCurrencyNotice from '../../../containers/multi-currency-notice.container';

import Purchase from '../../../lib/purchase';
import { CAPTURED } from '../../../lib/contribution-statuses';

class SummaryShareCommitted extends Component {
  multiCurrencyNotice() {
    const { membership: { failed, short, contributions } } = this.props;
    const captured = contributions && contributions.some(c => c.status === CAPTURED);

    if (failed || short || captured) return null;

    return <MultiCurrencyNotice />;
  }

  render() {
    const {
      membership,
      splitType,
      currentProductCostAmount,
      waitingToComplete,
      costRange,
      nextChargeAmount,
      anyPaymentsAuthorizing,
    } = this.props;
    const {
      fees: { consumerFee },
      shareAmount,
      allowedAmount,
      paymentSource,
      claimedSlots,
    } = membership;

    const costPerSlot = Purchase.isFixedPerPerson(splitType) ? currentProductCostAmount : null;
    const props = {
      amount: nextChargeAmount,
      shareAmount,
      allowedAmount,
      claimedSlots,
      costPerSlot,
      splitType,
      feesAmount: consumerFee,
      waitingToComplete,
      membership,
      onCommit: this.props.onCommit,
      onWithdraw: this.props.onWithdraw,
      chargeDate: this.props.chargeDate,
      costRange,
      anyPaymentsAuthorizing,
    };

    return (
      <div className="summary-share-committed yourshare-block gray">
        <div className="yourshare-box pt-4">
          <div className="contribute text-center">
            <YourExpectedCharge
              {...props}
              paymentSource={paymentSource}
              isMultiPayment={this.props.isMultiPayment}
            />
            {this.multiCurrencyNotice()}
            <div className="small-print container">
              <p className="mt-3 mb-0 text-center">
                <FormattedMessage
                  id="sumaryShare.committed.disclaimer"
                  defaultMessage="You won't be charged until enough group members commit to fund the full purchase amount."
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SummaryShareCommitted.defaultProps = {
  onCommit: () => {},
  onWithdraw: () => {},
  waitingToComplete: false,
  chargeDate: null,
};

export default SummaryShareCommitted;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/summary-share.committed.js